import 'adeliom-livesearch-js/dist/livesearch.css';
import Choices from "choices.js"
import initMasonry from '../components/_masonry';
import {init, afterChange} from "../utils/_livesearch";
import {
    initStoreLocator,
    refreshTagsFilters,
    removeMarkers,
    resetZoomAndCenter,
    updateData,
    geoFindMe
} from "../utils/_store-locator";
import locationAutocomplete from "../components/map/_location-autocomplete";
import { mapRange } from '../components/map/_map-range'

const settings = {
    filtersSelector: '[js-livesearch-form]',
    tagsSelector: '[js-livesearch-tags-results]',
    toggleMapSelector: '[js-toggle-map]',
    mapId: "#program-map",
    toggleMapClass: 'map-hidden',
    showMapText: 'Afficher la carte',
    hideMapText: 'Masquer la carte',
    allRegion: 'all'
}

const filtersForm = document.querySelector(settings.filtersSelector);
const tagsFilters = document.querySelector(settings.tagsSelector);

const toggleMap = document.querySelector(settings.toggleMapSelector);
const mapToToggle = document.querySelector(settings.mapId);
const findMe = document.querySelector('[js-find-me]');

if (filtersForm && toggleMap) {

    /**
     * Initialisation de Livesearch
     * @type {*}
     */
    const livesearch = init();

    /**
     * Initialisation de Masonry
     */
    const masonry = initMasonry();

    if (tagsFilters) {
        var choices = new Choices(tagsFilters, {
            searchEnabled: false,
            shouldSort: false,
            classNames: {
                containerOuter: 'choices choices--search',
            }
        });
    }

    /**
     * Gère l'actualisation front de la map et des résultats après requête via livesearch
     */
    afterChange(livesearch, response => {
        initMasonry();

        if (response.results.raw_items) {
            updateData(response.results.raw_items);
        } else {
            jumpTo('program-map');
            resetZoomAndCenter();
            removeMarkers();
        }

        if (response.params.region === settings.allRegion) {
            resetZoomAndCenter();
        }

        if (tagsFilters) {
            refreshTagsFilters(response.results.raw_tags, tagsFilters, choices)
        }
    });

    /**
     * Gère afficher / masquer la map
     */
    toggleMap.addEventListener('click', (e) => {
        e.preventDefault();
        if (toggleMap.classList.contains(settings.toggleMapClass)) {
            toggleMap.classList.remove(settings.toggleMapClass);
            mapToToggle.classList.remove(settings.toggleMapClass);
            toggleMap.innerHTML = settings.hideMapText;
        } else {
            toggleMap.classList.add(settings.toggleMapClass);
            mapToToggle.classList.add(settings.toggleMapClass);
            toggleMap.innerHTML = settings.showMapText;
        }
    });

    function jumpTo(anchor_id){
        const url = location.href;
        location.href = "#" + anchor_id;
        history.replaceState(null,null,url);
    }

    function initMap() {
        initStoreLocator();
        locationAutocomplete()
        mapRange();

        findMe.addEventListener('click', geoFindMe)
    }

    window.initMap = initMap;
}

